import React from 'react'
import img1 from './../../assets/img/Settings7533/hsdcl_certificate.jpg';
import img2 from './../../assets/img/Settings7533/scan0003_0.jpg';
import img3 from './../../assets/img/Settings7533/scan0004.jpg';
import img4 from './../../assets/img/Settings7533/scan0005.jpg';
import img5 from './../../assets/img/Settings7533/scan0006.jpg';
import img6 from './../../assets/img/Settings7533/scan0007.jpg';
import img7 from './../../assets/img/Settings7533/scan0008.jpg';
import img8 from './../../assets/img/Settings7533/scan0009.jpg';
import img9 from './../../assets/img/Settings7533/scan0010.jpg';
import img10 from './../../assets/img/Settings7533/scan0011.jpg';
import img11 from './../../assets/img/Settings7533/scan0012.jpg';
import img12 from './../../assets/img/Settings7533/scan0013.jpg';
import img13 from './../../assets/img/Settings7533/scan0014.jpg';
import img14 from './../../assets/img/Settings7533/scan0015.jpg';
import img15 from './../../assets/img/Settings7533/scan0016.jpg';
import img16 from './../../assets/img/Settings7533/scan0017.jpg';
import img17 from './../../assets/img/Settings7533/scan0018.jpg';
import img18 from './../../assets/img/Settings7533/scan0019_0.jpg';
import img19 from './../../assets/img/Settings7533/scan0020.jpg';
import img20 from './../../assets/img/Settings7533/scan0021.jpg';
import img21 from './../../assets/img/Settings7533/scan0022.jpg';
import img22 from './../../assets/img/Settings7533/scan0023.jpg';
import img23 from './../../assets/img/Settings7533/scan0024.jpg';
import img24 from './../../assets/img/Settings7533/scan0025.jpg';
import img25 from './../../assets/img/Settings7533/scan0026.jpg';
import img26 from './../../assets/img/Settings7533/scan0027.jpg';
import img27 from './../../assets/img/Settings7533/scan0028.jpg';
import img28 from './../../assets/img/Settings7533/scan0029.jpg';
import img29 from './../../assets/img/Settings7533/scan0030.jpg';
import img30 from './../../assets/img/Settings7533/scan0031.jpg';
import img31 from './../../assets/img/Settings7533/scan0032.jpg';
import img32 from './../../assets/img/Settings7533/scan0033.jpg';
import img33 from './../../assets/img/Settings7533/scan0034.jpg';
import img34 from './../../assets/img/Settings7533/scan0035.jpg';
import img35 from './../../assets/img/Settings7533/scan0036.jpg';
import img36 from './../../assets/img/Settings7533/scan0037.jpg';
import img37 from './../../assets/img/Settings7533/scan0038.jpg';
import img38 from './../../assets/img/Settings7533/scan0039.jpg';
import img39 from './../../assets/img/Settings7533/scan0040.jpg';
import img40 from './../../assets/img/Settings7533/scan0041.jpg';
import img41 from './../../assets/img/Settings7533/scan0042.jpg';
import img42 from './../../assets/img/Settings7533/scan0043.jpg';
import img43 from './../../assets/img/Settings7533/scan0044.jpg';
import img44 from './../../assets/img/Settings7533/scan0045_0.jpg';
import img45 from './../../assets/img/Settings7533/scan0046.jpg';
import img46 from './../../assets/img/Settings7533/scan0047_0.jpg';
import img47 from './../../assets/img/Settings7533/scan0048_0.jpg';
import img48 from './../../assets/img/Settings7533/scan0049.jpg';
import img49 from './../../assets/img/Settings7533/scan0050.jpg';
import img50 from './../../assets/img/Settings7533/scan0051.jpg';
import img51 from './../../assets/img/Settings7533/scan0052.jpg';
import img52 from './../../assets/img/Settings7533/scan0053.jpg';
import img53 from './../../assets/img/Settings7533/scan0054.jpg';
import img54 from './../../assets/img/Settings7533/scan0055.jpg';
import img55 from './../../assets/img/Settings7533/scan0056.jpg';
import img56 from './../../assets/img/Settings7533/scan0057.jpg';
import img57 from './../../assets/img/Settings7533/scan0058.jpg';
import img58 from './../../assets/img/Settings7533/scan0059.jpg';
import img59 from './../../assets/img/Settings7533/scan0060.jpg';
import img60 from './../../assets/img/Settings7533/scan0061.jpg';
import img61 from './../../assets/img/Settings7533/scan0062.jpg';
import img62 from './../../assets/img/Settings7533/scan0063.jpg';
import img63 from './../../assets/img/Settings7533/scan0064_0.jpg';
import img64 from './../../assets/img/Settings7533/scan0065.jpg';
import img65 from './../../assets/img/Settings7533/scan0066.jpg';
import img66 from './../../assets/img/Settings7533/scan0067.jpg';
import img67 from './../../assets/img/Settings7533/scan0068.jpg';
import img68 from './../../assets/img/Settings7533/scan0069.jpg';
import img69 from './../../assets/img/Settings7533/scan0070.jpg';
import img70 from './../../assets/img/Settings7533/scan0071.jpg';
import img71 from './../../assets/img/Settings7533/scan0072.jpg';
import img72 from './../../assets/img/Settings7533/scan0014.jpg';

const images = [
    img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
    img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
    img21, img22, img23, img24, img25, img26, img27, img28, img29, img30,
    img31, img32, img33, img34, img35, img36, img37, img38, img39, img40,
    img41, img42, img43, img44, img45, img46, img47, img48, img49, img50,
    img51, img52, img53, img54, img55, img56, img57, img58, img59, img60,
    img61, img62, img63, img64, img65, img66, img67, img68, img69, img70,
    img71,img72
];
const Gallery = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Photo Gallery </h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg "
      style={{ textAlign: "justify" }}
    >
       <div className="row mb-1 justify-content-between">
            
       {images.map((image, index) => (
                <div key={index} className="col-lg-4 mb-4 text-center gallery">
                    <img 
                        src={image} 
                        alt={`Seed Production ${index + 1}`} 
                        className="img-fluid rounded shadow-sm" 
                    />
                </div>
            ))}
            
        </div>

      
    </div>
    </div>
  )
}

export default Gallery
